export enum PageType {
  Documents = 'documents',
}
